// @flow

import * as Immutable                      from 'immutable';
import PropTypes                           from 'prop-types';
import randomInt                           from 'random-int';
import _                                   from 'underscore';
import randomString                        from '../utils/randomString';
import { serviceLocationShape }            from './serviceLocation';
import { serviceOpeningTimesShape }        from './serviceOpeningTimes';
import { serviceProviderShape }            from './serviceProvider';
import { taxonomyTermShapeWithinResource } from './taxonomyTerm';

// -----------------------------------------------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------------------------------------------

export type ServiceRecord = Immutable.Map<string, *>;

// -----------------------------------------------------------------------------------------------------------------
// Old domain config
// -----------------------------------------------------------------------------------------------------------------

const serviceSummaryShape  = {
  '@id':        PropTypes.string.isRequired,
  '@type':      PropTypes.string.isRequired,
  name:         PropTypes.string.isRequired,
  slug:         PropTypes.string.isRequired,
  provider:     PropTypes.shape(serviceProviderShape).isRequired,
  telephone:    PropTypes.string,
  logo:         PropTypes.string,
  image:        PropTypes.string,
  description:  PropTypes.string.isRequired,
  cost:         PropTypes.string,
  reviewsScore: PropTypes.number, // URLs to reviews
  reviewsCount: PropTypes.number, // URLs to reviews
  createdAt:    PropTypes.string.isRequired,
  updatedAt:    PropTypes.string.isRequired,
};
const serviceExtendedShape = {
  '@id':        PropTypes.string.isRequired,
  '@type':      PropTypes.string.isRequired,
  locations:    PropTypes.arrayOf(PropTypes.shape(serviceLocationShape)).isRequired,
  email:        PropTypes.string,
  website:      PropTypes.string,
  openingTimes: PropTypes.arrayOf(PropTypes.shape(serviceOpeningTimesShape)).isRequired,
};
const serviceTagsShape     = {
  '@id':      PropTypes.string.isRequired,
  '@type':    PropTypes.string.isRequired,
  taxonomies: PropTypes.shape({
    categories: PropTypes.shape({
      '@id':        PropTypes.string.isRequired,
      '@type':      PropTypes.string.isRequired,
      name:         PropTypes.string.isRequired,
      slug:         PropTypes.string.isRequired,
      resourceTags: PropTypes.arrayOf(PropTypes.shape(taxonomyTermShapeWithinResource)),
      taxonomy:     PropTypes.string.isRequired,
    }),
    keywords:   PropTypes.shape({
      '@id':        PropTypes.string.isRequired,
      '@type':      PropTypes.string.isRequired,
      name:         PropTypes.string.isRequired,
      slug:         PropTypes.string.isRequired,
      resourceTags: PropTypes.arrayOf(PropTypes.shape(taxonomyTermShapeWithinResource)),
      taxonomy:     PropTypes.string.isRequired,
    }),
  }).isRequired,
};

const serviceShape = {
  ...serviceSummaryShape,
  ...serviceExtendedShape,
  ...serviceTagsShape,
};

const servicePropType = PropTypes.shape(serviceShape);

const generateMockService = () => {

  const id = randomString(32);

  const slug = randomString(32);

  return {
    '@id':        '/services/' + id,
    '@type':      'http://schema.org/Thing',
    id:           id,
    name:         slug[0].toUpperCase() + slug.slice(1),
    slug:         slug,
    provider:     require('./serviceProvider').generageMockServiceProvider(),
    locations:    [],
    telephone:    `020${_.sample(['7', '8'], 1).join()}${_.sample('0123456789'.split(), 6).join()}`,
    email:        `${randomString()}@example.com`,
    website:      `http${_.sample(['', 's'], 1)}://${randomString()}.com`,
    openingTimes: [],
    logo:         'http://lorempixel.com',
    image:        'http://lorempixel.com',
    description:  Array(/* words */randomInt(5, 30)).map(/* word */ () => randomString(randomInt(1, 12))).join(' '),
    // cost:         PropTypes.string,
    categories:   Array(randomInt(3)).map(() => require('./serviceCategory').generateMockServiceCategory()),
    reviewsCount: randomInt(35),
    reviewsScore: randomInt(5),
    createdAt:    `${randomInt(2000, 2018)}-${randomInt(11) + 1}-${randomInt(30) + 1}`,
    updatedAt:    `${randomInt(2000, 2018)}-${randomInt(11) + 1}-${randomInt(30) + 1}`,
  };

};

export {
  serviceSummaryShape,
  serviceExtendedShape,
  serviceTagsShape,
  serviceShape,
  servicePropType,
  generateMockService,
};



// WEBPACK FOOTER //
// ./src/domain/service.js